import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { getProgramBySlug } from '@/mocks/programProfile';
import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';
import ProgramCoverHeader from './components/ProgramCoverHeader';
import ProgramDescriptionSection from './components/ProgramDescriptionSection';
import ProgramScheduleSection from './components/ProgramScheduleSection';
import ProgramFeedSection from './components/ProgramFeedSection';
import ProgramEpisodesSection from './components/ProgramEpisodesSection';
import ProgramEventsSection from './components/ProgramEventsSection';
import ProgramTopFansSection from './components/ProgramTopFansSection';

export default function ProgramPage() {
  const { programSlug } = useParams<{ programSlug: string }>();
  const profile = programSlug ? getProgramBySlug(programSlug) : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [programSlug]);

  if (!profile) {
    return (
      <div className="min-h-screen bg-background-50 flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center">
          <div className="text-center px-4">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-foreground-100 flex items-center justify-center">
              <i className="ri-broadcast-line text-3xl text-foreground-400"></i>
            </div>
            <h1 className="text-2xl font-bold text-foreground-950 mb-2">Programa no encontrado</h1>
            <p className="text-foreground-500 mb-6">El programa que buscas no existe o fue removido.</p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-xl transition-all cursor-pointer text-sm whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              Volver al Dial
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background-100/50 flex flex-col">
      {/* Header - oculto, usamos nuestro propio cover */}
      <div className="hidden">
        <Header />
      </div>

      {/* Cover + Profile Header */}
      <ProgramCoverHeader profile={profile} />

      {/* Main Content */}
      <main className="flex-1 max-w-5xl mx-auto px-4 md:px-6 py-6 md:py-8 w-full">
        <div className="space-y-5">
          {/* Descripción */}
          <ProgramDescriptionSection profile={profile} />

          {/* Horarios */}
          <ProgramScheduleSection profile={profile} />

          {/* Publicaciones */}
          <ProgramFeedSection profile={profile} />

          {/* Episodios */}
          <ProgramEpisodesSection profile={profile} />

          {/* Eventos */}
          <ProgramEventsSection profile={profile} />

          {/* Top Fans */}
          <ProgramTopFansSection profile={profile} />
        </div>
      </main>

      <Footer />

      {/* Spacer for global player */}
      <div className="h-14 md:h-16"></div>
    </div>
  );
}